import "./src/accordion.js"; import "./src/frontpage.js"; import "./src/menu.js"; import "./src/parallax.js";